/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it handle non-English characters?`)
};

const es_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Maneja caracteres que no son ingleses?`)
};

const de_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitet es Nicht-Englisch-Zeichen?`)
};

const nl_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondersteunt het niet-Engelse karakters?`)
};

const fr_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère-t-il les caractères non anglais ?`)
};

const it_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisce i caratteri non inglesi?`)
};

const pt_br2_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele lida com caracteres não-ingleses?`)
};

const pt_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processa caracteres não-ingleses?`)
};

const ja_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英語以外の文字を処理しますか?`)
};

const zh_ue_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它能处理非英文字符吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_faq2_q", locale)
	if (locale === "en") return en_ue_faq2_q(inputs)
	if (locale === "es") return es_ue_faq2_q(inputs)
	if (locale === "de") return de_ue_faq2_q(inputs)
	if (locale === "nl") return nl_ue_faq2_q(inputs)
	if (locale === "fr") return fr_ue_faq2_q(inputs)
	if (locale === "it") return it_ue_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_ue_faq2_q(inputs)
	if (locale === "pt") return pt_ue_faq2_q(inputs)
	if (locale === "ja") return ja_ue_faq2_q(inputs)
	return zh_ue_faq2_q(inputs)
};